export const ingredientRules = {
    name: [(v) => !!v || "Ingredient name is required"],
    ingredientType: [(v) => !!v || "Ingredient type is required"],
    price: [(v) => !!v || "Price is required"],
    quantity: [(v) => !!v || "Quantity is required"],
    currency: [(v) => !!v || "Currency is required"],
    unitId: [(v) => !!v || "Unit ID is required"],
    
    
    // scientificName: [(v) => !!v || "Scientific name is required"],
    // suppliers: [(v) => !!v || "Suppliers is required"],
    // graphicOriginId: [(v) => !!v || "Geographic origin is required"],
    
    CP: [(v) => !!v || "Crude Protein is required"],
    DM: [(v) => !!v || "Dry Matter is required"],
    TDN: [(v) => !!v || "Total Digestible Nutrients is required"],
    CA: [(v) => !!v || "Calcium is required"],
    P: [(v) => !!v || "Phosphorus is required"],
    
    
    // digestibleEnergy: [(v) => !!v || "Digestible energy is required"],
    // metabolizableEnergy: [(v) => !!v || "Metabolizable energy is required"],
    // netEnergy: [(v) => !!v || "Net energy is required"],
  
    // usageInstrictions: [(v) => !!v || "Usage Instructions is required"],
    // riskWarning: [(v) => !!v || "Risk Warning province is required"],
    // speciesId: [(v) => !!v || "Species ID is required"],
    // minInclusionRatio: [(v) => !!v || "Min. Inclusion Ration is required"],
    // maxInclusionRatio: [(v) => !!v || "Max. Inclusion ration is required"],
    
    // provider: [(v) => !!v || "Provider is required"],
    // date: [(v) => !!v || "Date is required"],
    // firstName: [(v) => !!v || "First name is required"],
    // lastName: [(v) => !!v || "Last name is required"],
    // farmInfoCountry: [(v) => !!v || "Farm info country is required"],
    // farmProvince: [(v) => !!v || "Farm province is required"],
    
};
